export default __webpack_public_path__ + "static/media/segre09.74387416.jpg";